import {
  useBrowserOptions,
  useCompanyOrgType,
  useCountryOptions,
  useDeviceOptions,
  useOssOptions,
} from '@va/dashboard/shared/filters';
import { useTranslate } from '@va/localization';
import { MultiSelectFilter, SingleSelectFilter, TextFilter } from '@va/shared/feature-filters';
import { Filter, FilterOperators } from '@va/types/filters';
import { useMemo } from 'react';

export const useSegmentsFilterOptions = () => {
  const translate = useTranslate();

  const countryOptions = useCountryOptions();
  const deviceOptions = useDeviceOptions();
  const companyOrgTypeOptions = useCompanyOrgType();

  const allFilterOptions: Filter[] = useMemo(() => {
    return [
      new SingleSelectFilter({
        id: 'countryCode',
        label: translate('filter.countryName'),
        name: 'countryCode',
        inputProps: {
          useOptions: () => ({ data: countryOptions }),
          label: translate('filters.placeholder.countryName'),
          showSearchInput: true,
        },
        operator: FilterOperators.is,
        operatorOptions: [FilterOperators.is, FilterOperators.isNot],
      }),
      new SingleSelectFilter({
        id: 'browserName',
        name: 'browserName',
        label: translate('filter.browserName'),
        inputProps: {
          useOptions: useBrowserOptions,
          label: translate('filters.placeholder.browserName'),
          showSearchInput: true,
        },
        operator: FilterOperators.is,
        operatorOptions: [FilterOperators.is, FilterOperators.isNot],
      }),
      new TextFilter({
        id: 'browserVersion',
        name: 'browserVersion',
        label: translate('filter.browserVersion'),
        inputProps: { placeholder: translate('filters.placeholder.browserVersion') },
        operator: FilterOperators.is,
        operatorOptions: [FilterOperators.is, FilterOperators.isNot],
      }),
      new TextFilter({
        id: 'ip',
        name: 'ip',
        label: translate('filter.ip'),
        inputProps: { placeholder: translate('filters.placeholder.ip') },
        operator: FilterOperators.contains,
        operatorOptions: [FilterOperators.contains, FilterOperators.doesNotContain],
      }),
      new SingleSelectFilter({
        id: 'deviceType',
        name: 'deviceType',
        label: translate('filter.deviceType'),
        inputProps: { useOptions: () => ({ data: deviceOptions }), label: translate('filters.placeholder.deviceType') },
        operator: FilterOperators.is,
        operatorOptions: [FilterOperators.is, FilterOperators.isNot],
      }),
      new TextFilter({
        id: 'cityName',
        name: 'cityName',
        label: translate('filter.cityName'),
        inputProps: { placeholder: translate('filters.placeholder.cityName') },
        operator: FilterOperators.contains,
        operatorOptions: [FilterOperators.contains, FilterOperators.doesNotContain],
      }),

      new SingleSelectFilter({
        id: 'platform',
        name: 'platform',
        label: translate('filter.platform'),
        inputProps: {
          useOptions: useOssOptions,
          label: translate('filters.placeholder.platform'),
          showSearchInput: true,
        },
        operatorOptions: [FilterOperators.is, FilterOperators.isNot],
      }),
      new TextFilter({
        id: 'display',
        name: 'display',
        label: translate('filter.display'),
        inputProps: { placeholder: translate('filters.placeholder.display') },
        operator: FilterOperators.is,
        operatorOptions: [FilterOperators.is, FilterOperators.isNot],
      }),
      new TextFilter({
        id: 'companyOrgName',
        name: 'companyOrgName',
        label: translate('filter.companyOrgName'),
        inputProps: { placeholder: translate('filters.placeholder.companyOrgName') },
        operator: FilterOperators.contains,
        operatorOptions: [FilterOperators.contains, FilterOperators.doesNotContain],
      }),
      new MultiSelectFilter({
        id: 'companyOrgType',
        name: 'companyOrgType',
        label: translate('filter.companyOrgType'),
        inputProps: { useOptions: () => ({ data: companyOrgTypeOptions }) },
      }),
    ];
  }, [companyOrgTypeOptions, countryOptions, deviceOptions, translate]);

  return allFilterOptions;
};
